import { CampaignSource } from 'utils/constants/campaign';

import hhIconMobile from 'assets/hh_logo_16.svg';
import hhIconDesktop from 'assets/hh_logo_24.svg';
import vkIconMobile from 'assets/vk_logo_16.svg';
import vkIconDesktop from 'assets/vk_logo_24.svg';
import yandexIconMobile from 'assets/ya_logo_16.svg';
import yandexIconDesktop from 'assets/ya_logo_24.svg';

interface SourceIcons {
    desktop: string;
    mobile: string;
    label: string;
    tooltipTrl: string;
    tooltipTrlList?: string[];
}

export const BANNER_SOURCE_ICONS: Partial<Record<CampaignSource, SourceIcons>> = {
    [CampaignSource.HH]: {
        desktop: hhIconDesktop,
        mobile: hhIconMobile,
        label: 'BannersPage.banner.sources.hh',
        tooltipTrl: 'BannersPage.banner.sources.hh',
    },
    [CampaignSource.VKAds]: {
        desktop: vkIconDesktop,
        mobile: vkIconMobile,
        label: 'BannersPage.banner.sources.vk',
        tooltipTrl: 'CampaignsDashboard.CampaignsTable.CampaignSources.vk',
        tooltipTrlList: [
            'CampaignsDashboard.CampaignsTable.CampaignSources.vk.li1',
            'CampaignsDashboard.CampaignsTable.CampaignSources.vk.li2',
            'CampaignsDashboard.CampaignsTable.CampaignSources.vk.li3',
            'CampaignsDashboard.CampaignsTable.CampaignSources.vk.li4',
        ],
    },
    [CampaignSource.Yandex]: {
        desktop: yandexIconDesktop,
        mobile: yandexIconMobile,
        label: 'BannersPage.banner.sources.yandex',
        tooltipTrl: 'BannersPage.banner.sources.yandex',
    },
};
